module.exports = __webpack_public_path__ + "img/2-3porte.ed751160.svg";